module.exports = __webpack_public_path__ + "media/images/home/faq_question_icon-6d3203e4fc02f9c2cae6520c29059d48.svg";